import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { State } from './types';

const hasState = (states: State[], state: State): boolean => {
  return !!states.find((someState) => someState.stateName === state.stateName);
};

const getAllStates = async () => {
  return axios<State[], BaseResponse<State[]>, void>({
    url: '/states',
    method: 'get',
  });
};

export const useStates = () => {
  const [states, setStates] = useState<string[]>([]);

  const { data, isLoading } = useQuery(['states'], getAllStates, {
    useErrorBoundary: false,
    refetchOnWindowFocus: true,
    retry: 3,
  });

  useEffect(() => {
    const responseBody = data?.data;
    const content = responseBody?.data;
    const newStates = Array.isArray(content) ? content : [];

    const uniqueStates: State[] = [];
    newStates.forEach((state) => {
      if (!hasState(uniqueStates, state)) {
        uniqueStates.push(state);
      }
    });

    setStates(uniqueStates.map((state) => state.stateName));
  }, [data]);

  return {
    states,
    isLoading,
  };
};
